import { Box, Divider, Tabs, Tab, useTheme } from "@mui/material";
import { VisualizationCardType } from "../types";
import { useState } from "react";
import BarChartIcon from "@mui/icons-material/BarChart";
import PieChartIcon from "@mui/icons-material/PieChart";
import { formatLabel } from "../../../views/insights/utils";
import { BarChart } from "../../bar-chart";
import { PieChart } from "../../pie-chart";

export const VisualizationCardContent = ({
  type,
  data,
  onTypeChange = () => {},
}: {
  type?: VisualizationCardType;
  data: any[];
  onTypeChange?: (type: VisualizationCardType) => void;
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const svgHeight = 280;
  const textColor = isDark ? "#ddd" : "#000";
  const getId = (d: any) => d.id;
  const lineColor = theme.palette.divider;

  const [cardType, setCardType] = useState<VisualizationCardType>(
    type || VisualizationCardType.Pie
  );

  const pieChart = (
    <PieChart
      minHeight={svgHeight}
      maxHeight={svgHeight}
      data={data}
      textColor={textColor}
      getValue={(d) => d.count}
      strokeColor={isDark ? "#181818" : "#fff"}
      getLabel={(d) => `${d.label ?? formatLabel(d.value)}(${d.count})`}
      getId={getId}
    />
  );

  const barChart = (
    <BarChart
      minHeight={svgHeight}
      maxHeight={svgHeight}
      data={data}
      textColor={textColor}
      getValue={(d) => d.count}
      getLabel={(d) => d.label ?? formatLabel(d.value)}
      lineColor={lineColor}
      getId={getId}
    />
  );
  const chart = cardType === VisualizationCardType.Pie ? pieChart : barChart;

  const handleTypeChange = (value: VisualizationCardType) => {
    setCardType(value);
    onTypeChange(value);
  };

  return (
    <>
      <Box sx={{ minHeight: svgHeight + 8, maxHeight: svgHeight + 8, height: svgHeight + 8 }}>{chart}</Box>
      <Box>
        <Divider />
        <Tabs
          variant="fullWidth"
          value={cardType}
          onChange={(_, value) => handleTypeChange(value)}
        >
          <Tab value={VisualizationCardType.Pie} icon={<PieChartIcon />} />
          <Tab value={VisualizationCardType.Bar} icon={<BarChartIcon />} />
        </Tabs>
      </Box>
    </>
  );
};
